import { render, staticRenderFns } from "./FlagGreatBritain.vue?vue&type=template&id=70690b2f&"
import script from "./FlagGreatBritain.vue?vue&type=script&lang=js&"
export * from "./FlagGreatBritain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports